import React, { useEffect, useMemo, useRef, useState } from 'react';
import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';
import cn from 'classnames';
import { pathgen } from 'object-path-generator';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { CircularLoader } from "../CircularLoader";
import styles from "./PdfViewer.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const workerSrc = '/pdf.worker.min.js';
export const PdfViewerTestIds = pathgen('PdfViewerTestIds');
const pageLayout = {
  buildPageStyles: () => ({
    margin: '0 auto !important',
    padding: 0
  })
};
export const PdfViewer = _ref => {
  let {
    getFileUrl,
    singlePageStyle,
    hideSinglePageLoader,
    style
  } = _ref;
  const styleIdRef = useRef("pdf-viewer-single-page-style-".concat(Math.random().toString(36).substr(2, 9)));
  const [url, setUrl] = useState('');
  useEffect(() => {
    const resolveUrl = async () => {
      const resolvedUrl = await getFileUrl();
      setUrl(resolvedUrl);
    };
    resolveUrl();
  }, [getFileUrl]);
  const loader = useMemo(() => /*#__PURE__*/_jsx("div", {
    "data-testid": PdfViewerTestIds.loader(),
    style: {
      position: 'absolute',
      top: 'calc(50% - 16px)',
      left: 'calc(50% - 16px)'
    },
    children: /*#__PURE__*/_jsx(CircularLoader, {
      size: 32
    })
  }), []);
  useEffect(() => {
    if (!singlePageStyle) {
      const existingStyle = document.getElementById(styleIdRef.current);
      if (existingStyle) {
        existingStyle.remove();
      }
      return;
    }
    const cssProperties = [];
    Object.entries(singlePageStyle).forEach(_ref2 => {
      let [key, value] = _ref2;
      if (value === undefined || value === null) return;
      const cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      let cssValue;
      if (typeof value === 'number') {
        const unitlessProps = ['opacity', 'z-index', 'zoom', 'order', 'flex-grow', 'flex-shrink'];
        cssValue = unitlessProps.includes(cssKey) ? String(value) : "".concat(value, "px");
      } else {
        cssValue = String(value);
      }
      cssProperties.push("".concat(cssKey, ": ").concat(cssValue));
    });
    if (cssProperties.length === 0) return;
    const styleId = styleIdRef.current;
    let styleElement = document.getElementById(styleId);
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }
    styleElement.textContent = ".rpv-core__page-layer::after { ".concat(cssProperties.join('; '), "; }");
    return () => {
      const styleToRemove = document.getElementById(styleId);
      if (styleToRemove) {
        styleToRemove.remove();
      }
    };
  }, [singlePageStyle]);
  if (!url) return loader;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": PdfViewerTestIds.container(),
    className: cn(styles.container, {
      [styles.hideLoader]: hideSinglePageLoader
    }),
    style: style,
    children: /*#__PURE__*/_jsx(Worker, {
      workerUrl: workerSrc,
      children: /*#__PURE__*/_jsx(Viewer, {
        renderLoader: () => loader,
        fileUrl: url,
        defaultScale: SpecialZoomLevel.PageWidth,
        pageLayout: pageLayout
      })
    })
  });
};